import React from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

export const renderFormField = ({
  field,
  formData,
  errors,
  handleChange,
  handleCropChange,
  cropOptions,
  postOffices,
  pincodeError,
}) => {
  const {
    name,
    label,
    type,
    required,
    gridProps,
    options,
    inputProps,
    disabled,
    multiline,
    rows,
  } = field;

  // Special handling for crops field
  if (name === "crops") {
    return (
      <Grid item xs={12} key={name}>
        <Autocomplete
          multiple
          options={cropOptions}
          getOptionLabel={(option) => option.name}
          value={cropOptions.filter((crop) => formData.crops.includes(crop.id))}
          onChange={handleCropChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Crops"
              error={!!errors.crops}
              helperText={errors.crops || "Select at least one crop"}
            />
          )}
        />
      </Grid>
    );
  }

  // Special handling for state and district fields
  if (name === "state" || name === "district") {
    return (
      <Grid item {...gridProps} key={name}>
        <TextField
          fullWidth
          label={label}
          name={name}
          value={formData[name]}
          disabled
          error={!!errors[name]}
          helperText={errors[name]}
        />
      </Grid>
    );
  }

  // Special handling for post office field
  if (name === "post_office") {
    return (
      <Grid item xs={12} key={name}>
        <FormControl fullWidth error={!!errors.post_office}>
          <InputLabel>Post Office *</InputLabel>
          <Select
            name="post_office"
            value={formData.post_office}
            onChange={handleChange}
            label="Post Office *"
          >
            {postOffices.map((office) => (
              <MenuItem key={office.Name} value={office.Name}>
                {office.Name}
              </MenuItem>
            ))}
          </Select>
          {errors.post_office && (
            <FormHelperText>{errors.post_office}</FormHelperText>
          )}
        </FormControl>
      </Grid>
    );
  }

  // Handle select fields
  if (type === "select") {
    return (
      <Grid item {...gridProps} key={name}>
        <FormControl fullWidth error={!!errors[name]}>
          <InputLabel>{label} *</InputLabel>
          <Select
            name={name}
            value={formData[name]}
            onChange={handleChange}
            label={`${label} *`}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {errors[name] && <FormHelperText>{errors[name]}</FormHelperText>}
        </FormControl>
      </Grid>
    );
  }

  // Default TextField rendering
  return (
    <Grid item {...gridProps} key={name}>
      <TextField
        required={required}
        fullWidth
        label={label}
        name={name}
        type={type}
        multiline={multiline}
        rows={rows}
        disabled={disabled}
        inputProps={inputProps}
        value={formData[name]}
        onChange={handleChange}
        error={!!errors[name] || (name === "pin_code" && Boolean(pincodeError))}
        helperText={
          name === "pin_code" ? pincodeError || errors[name] : errors[name]
        }
      />
    </Grid>
  );
};
